// component
import SvgColor from '../../../components/svg-color';


// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;


// const usuario = JSON.parse(localStorage.getItem('userData'))

const navConfig = [
  {
    title: 'Dashboard',
    path: '/os/inicio',
    icon: icon('ic_analytics'),
    supervisor: true
  },
  {
    title: 'OS',
    path: '/os/os',
    icon: icon('ic_cart'),
    supervisor: false
  },
  {
    title: 'Kanban',
    path: '/os/kanban',
    icon: icon('list-outline'),
    supervisor: true
  },
  {
    title: 'Cronograma',
    path: '/os/cronograma',
    icon: icon('agenda'),
    supervisor: false
  }
].filter(Boolean);

export default navConfig;
